import styled from 'styled-components';

export const EachCourse = styled.div`
  margin-top: ${({ theme }) => theme.spacing.l};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.5s ease forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .top {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xs};
  }

  .top a {
    letter-spacing: 0.1rem;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.grey5};
    transition: color 0.3s ease;
    /* border: 1px solid green; */

    &:hover {
      color: ${({ theme }) => theme.colors.orange5};
    }
  }

  .title {
    /* border: 1px solid orange; */
    font-family: 'Oswald', sans-serif;
    color: ${({ theme }) => theme.colors.grey5};
    letter-spacing: ${({ theme }) => theme.letterSpacing.courseTitles};
    padding-bottom: ${({ theme }) => theme.spacing.xxs};
    font-size: 1.05rem;
    transition: color 0.3s ease;
    &:hover {
      color: ${({ theme }) => theme.colors.orange5};
    }
  }

  button {
    width: 250px;
    max-width: 100%;
    transition: background-color 0.3s ease;
  }

  p {
    font-weight: 600;
    margin-bottom: ${({ theme }) => theme.spacing.xxs};
    color: ${({ theme }) => theme.colors.grey5};
    /* font-size: 0.8rem; */
    /* border: 1px solid blue; */
  }

  p span {
    font-style: italic;
    /* font-size: 0.8rem; */
    color: ${({ theme }) => theme.colors.grey3};
    /* border: 1px solid red; */
  }

  @media screen and (max-width: 600px) {
    button {
      min-width: 30%;
      /* border: 2px solid red; */
    }
  }
`;

export const BottomCourseContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.m};
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.5s ease forwards;
  /* border: 1px solid purple; */
  span {
    color: ${({ theme }) => theme.colors.grey5};
    /* border: 1px solid pink; */
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    align-items: start;
    gap: ${({ theme }) => theme.spacing.s};
  }
`;

export const CourseStatusContainer = styled.div`
  height: 100vh;
  text-align: center;
  text-transform: capitalize;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.5s ease forwards;

  button {
    margin-top: ${({ theme }) => theme.spacing.xl};
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    border: none;
    padding: ${({ theme }) => theme.spacing.m};
    border-radius: ${({ theme }) => theme.borderRadius};
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.primaryDark};
    }
  }
`;
